import React from 'react';

/**
 * AdminSessionWarning component for displaying session timeout warnings
 */
const AdminSessionWarning = ({ 
  isVisible, 
  timeRemaining, 
  onExtendSession, 
  onSignOut 
}) => {
  if (!isVisible) return null;

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gray-800 rounded-lg shadow-xl p-6 max-w-md w-full mx-4 border border-yellow-500">
        <div className="flex items-center mb-4">
          <div className="text-yellow-500 text-2xl mr-3">⚠️</div>
          <h3 className="text-lg font-semibold text-white dark:text-white">Session Expiring Soon</h3>
        </div>
        
        <p className="text-gray-300 mb-4 dark:text-gray-600">
          Your admin session will expire in{' '}
          <span className="font-mono text-yellow-400">
            {minutes}:{seconds.toString().padStart(2, '0')}
          </span>
          {' '}due to inactivity.
        </p>
        
        <p className="text-sm text-gray-400 mb-6">
          Click "Stay Signed In" to extend your session, or "Sign Out" to end your session now.
        </p>
        
        <div className="flex space-x-3">
          <button
            onClick={onExtendSession}
            className="flex-1 px-4 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors font-medium dark:text-white"
          >
            Stay Signed In
          </button>
          <button
            onClick={onSignOut}
            className="flex-1 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors font-medium dark:text-white"
          >
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminSessionWarning;
